import { FC } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AdminOrganizationResDto } from "service/api/estabrookSchemas";
import { AdRoutes } from "@/constants/ad-routes";
import { FilterState, UpdateFilter } from "../hooks/useOrganizationsFilters";
import useOrganizationAccessToggle from "../hooks/useOrganizationAccessToggle";
import useDeleteOrganization from "../hooks/useDeleteOrganization";
import OrganizationsListHeader from "./OrganizationsListHeader";
import OrganizationCard from "./OrganizationCard";
import OrganizationAccessConfirmDialog from "./OrganizationAccessConfirmDialog";
import OrganizationDeleteConfirmDialog from "./OrganizationDeleteConfirmDialog";

export interface OrganizationsListProps {
  data?: AdminOrganizationResDto[];
  filters: FilterState;
  updateFilter: UpdateFilter;
}

const OrganizationsList: FC<OrganizationsListProps> = ({
  data = [],
  filters,
  updateFilter,
}) => {
  const navigate = useNavigate();

  const {
    pendingOrganization,
    isSubmitting,
    requestToggle,
    confirmToggle,
    cancelToggle,
  } = useOrganizationAccessToggle();

  const {
    pendingOrganization: organizationPendingDelete,
    isSubmitting: isDeleting,
    requestDelete,
    confirmDelete,
    cancelDelete,
  } = useDeleteOrganization();

  return (
    <Box sx={{ mt: "24px" }}>
      <OrganizationsListHeader
        sortOptions={filters.sortOptions}
        onSortChange={(sortOptions) => updateFilter("sortOptions", sortOptions)}
      />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {data.map((organization) => (
          <OrganizationCard
            key={organization.id}
            organization={organization}
            onToggleAccessRequest={requestToggle}
            onEditRequest={(org) =>
              navigate(
                AdRoutes.editOrganization.replace(":organizationId", org.id),
              )
            }
            onDeleteRequest={requestDelete}
          />
        ))}
      </Box>
      <OrganizationAccessConfirmDialog
        organization={pendingOrganization}
        isSubmitting={isSubmitting}
        onConfirm={confirmToggle}
        onCancel={cancelToggle}
      />
      <OrganizationDeleteConfirmDialog
        organization={organizationPendingDelete}
        isSubmitting={isDeleting}
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </Box>
  );
};

export default OrganizationsList;
